import React from "react";
import PersistentHeader from "../components/PersistentHeader";

const OnxPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-green-50 dark:from-gray-900 dark:via-gray-800 dark:to-green-900">
      <div className="max-w-3xl mx-auto p-4 text-gray-900 dark:text-white">
        <h2 className="text-2xl font-bold mb-4">OnX Page</h2>
        <p className="mb-6">This page is reserved for OnX features and integrations. Add your content here.</p>
        {/* BEGIN Trail Run Project */}
        <h2 className="text-xl font-bold mb-2">Trail Run Project</h2>
        <div className="rounded-lg shadow-lg overflow-hidden border border-gray-300 bg-white">
          <iframe
            style={{ width: "100%", maxWidth: "1200px", height: "500px" }}
            frameBorder="0"
            scrolling="no"
            src="https://trailrunproject.com/widget/map?favs=1&location=fixed&x=-10997714&y=5153238&z=4&h=500"
            title="Trail Run Project Map"
            allowFullScreen
          ></iframe>
        </div>
        {/* END Trail Run Project */}
        {/* BEGIN Hiking Project */}
        <h2 className="text-xl font-bold mt-8 mb-2">Hiking Project</h2>
        <div className="rounded-lg shadow-lg overflow-hidden border border-gray-300 bg-white">
          <iframe
            style={{ width: "100%", maxWidth: "1200px", height: "500px" }}
            frameBorder="0"
            scrolling="no"
            src="https://hikingproject.com/widget/map?favs=1&location=fixed&x=-13587335&y=5494139&z=8.4&h=500"
            title="Hiking Project Map"
            allowFullScreen
          ></iframe>
        </div>
        {/* END Hiking Project */}
        {/* BEGIN MTB Project */}
        <h2 className="text-xl font-bold mt-8 mb-2">MTB Project</h2>
        <div className="rounded-lg shadow-lg overflow-hidden border border-gray-300 bg-white">
          <iframe
            style={{ width: "100%", maxWidth: "1200px", height: "500px" }}
            frameBorder="0"
            scrolling="no"
            src="https://mtbproject.com/widget/map?favs=1&location=fixed&x=-12194009&y=4663858&z=6.4&h=500"
            title="MTB Project Map"
            allowFullScreen
          ></iframe>
        </div>
        {/* END MTB Project */}
      </div>
    </div>
  );
};

export default OnxPage;
